import { Alert, Heading, Paragraph } from '@digdir/designsystemet-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const MissingRomoppvarmingWarning = () => {
  const { t } = useTranslation();

  return (
    <Alert data-color="warning">
      <Heading
        data-size="xs"
        level={2}
        style={{
          marginBottom: 'var(--ds-size-2)'
        }}
      >
        {t('form.oppvarming.noRomoppvarmingWarning.title')}
      </Heading>
      <Paragraph>{t('form.oppvarming.noRomoppvarmingWarning.info')}</Paragraph>
    </Alert>
  );
};
